import { render, staticRenderFns } from "./modelWatchInfoRight.vue?vue&type=template&id=60381fce&scoped=true&"
import script from "./modelWatchInfoRight.vue?vue&type=script&lang=js&"
export * from "./modelWatchInfoRight.vue?vue&type=script&lang=js&"
import style0 from "./modelWatchInfoRight.vue?vue&type=style&index=0&id=60381fce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60381fce",
  null
  
)

export default component.exports